var React = require('react');

function Book (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 6H9C10.1046 6 11 6.89543 11 8V18.5585L10.5562 18.4105C9.74042 18.1386 8.88619 18 8.02633 18H5C4.44772 18 4 17.5523 4 17V7C4 6.44772 4.44772 6 5 6ZM12.3162 20.8946C12.111 20.963 11.889 20.963 11.6838 20.8946L9.9237 20.3079C9.3119 20.104 8.67123 20 8.02633 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H9C10.1947 4 11.2671 4.52376 12 5.35418C12.7329 4.52376 13.8053 4 15 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H15.9737C15.3288 20 14.6881 20.104 14.0763 20.3079L12.3162 20.8946ZM15 6H19C19.5523 6 20 6.44772 20 7V17C20 17.5523 19.5523 18 19 18H15.9737C15.1138 18 14.2596 18.1386 13.4438 18.4105L13 18.5585V8C13 6.89543 13.8954 6 15 6Z","fill":"black"}));
}

Book.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Book;

Book.default = Book;
